import bidProfile from './bidProfile';
import bidProfileDraft from './bidProfileDraft';
import bidProfileManagement from './bidProfileManagement';
import employeeBidSelection from '../../store/bidSelection';
import employeePreferencesReport from '../../store/employeePreferencesReport';
import employeeBiddingResultsReport from '../../store/employeeBiddingResultsReport';
import unawardedShiftlinesReport from '../../store/unawardedShiftlinesReport';
import managerAppData from './appData';
import workplanPublishProgress from './workplanPublishProgress';

export default {
    bidProfile,
    bidProfileDraft,
    bidProfileManagement,
    employeeBidSelection,
    employeePreferencesReport,
    employeeBiddingResultsReport,
    unawardedShiftlinesReport,
    managerAppData,
    workplanPublishProgress,
};
